/** Только цифры из строки. */
export function phoneDigits(raw: string): string {
  return (raw ?? '').replace(/\D/g, '');
}

/**
 * Приводит ввод к российскому виду и форматирует по маске +7(XXX)XXX-XX-XX.
 * Незаполненный хвост маски не дорисовывается — форма растёт по мере набора.
 */
export function formatPhoneRu(raw: string): string {
  let d = phoneDigits(raw);
  if (d === '') return '';
  // ведущая 8 или 7 -> код страны 7
  if (d[0] === '8' || d[0] === '7') d = d.slice(1);
  d = d.slice(0, 10);

  let out = '+7';
  if (d.length > 0) out += `(${d.slice(0, 3)}`;
  if (d.length >= 3) out += ')';
  if (d.length > 3) out += d.slice(3, 6);
  if (d.length > 6) out += `-${d.slice(6, 8)}`;
  if (d.length > 8) out += `-${d.slice(8, 10)}`;
  return out;
}

/** Готов ли номер (10 значащих цифр). */
export function phoneComplete(raw: string): boolean {
  let d = phoneDigits(raw);
  if (d[0] === '8' || d[0] === '7') d = d.slice(1);
  return d.length === 10;
}
